module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/instagram/suns_sns_01-8550113ffae85bdb8126aba51d90d06f.jpg";